import TopHeadScreen from "../../component/layout/tophead";
import SidebarScreen from "../../component/layout/sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import Button from "react-bootstrap/Button";
import { LuPencilLine } from "react-icons/lu";
import { FiPlus } from "react-icons/fi";
import { FiMoreVertical } from "react-icons/fi";
import Dropdown from "react-bootstrap/Dropdown";
import NavItem from "react-bootstrap/NavItem";
import NavLink from "react-bootstrap/NavLink";
import { MdDeleteOutline } from "react-icons/md";

import { HiOutlineLightBulb } from "react-icons/hi";
import { FaCheck } from "react-icons/fa6";
import { BsBriefcase } from "react-icons/bs";
import { SlGraduation } from "react-icons/sl";
import { LiaAwardSolid } from "react-icons/lia";

import { useEffect, useState } from "react";
import { RootState } from "../../store/store";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import { AppRoute } from "../../router/routerConstants";
import AddExpericeModal from "./common/add-experice-modal";
import { setResumeDetails } from "../../store/resume.store";
import AgentSidebarScreen from "../../component/layout/agent-sidebar";
import AgentTopHeadScreen from "../../component/layout/agent-header";
import { useLocation } from "react-router-dom";
interface Experience {
  from: Date | null;
  to: Date | null;
  role: string;
  company: string;
  responsibilities: string[];
}

interface WorkExperiences {
  experiences: Experience[];
}

const ProfileAddedWorkExperienceScreen = () => {
  const [showEXP, setShowEXP] = useState(false);
  const handleCloseEXP = () => setShowEXP(false);
  const [isBulkEdit, setIsBulkEdit] = useState(false);
  const [isSingleEdit, setIsSingleEdit] = useState(false);
  const defaultWorkExperiences = {
    experiences: [
      {
        from: null,
        to: null,
        role: "",
        company: "",
        responsibilities: [],
      },
    ],
  };

  const [experienceList, setExperienceList] = useState<WorkExperiences>(
    defaultWorkExperiences
  );
  const [NavigateTo] = useCustomNavigate();
  const { resumeDetails,resumeList } = useSelector(
    (state: RootState) => state.resumeSlice
  );
  const location = useLocation();
  const {editId}= location?.state || {};
  const selectedResume = editId? resumeList.find(resume => resume._id === editId) : null;

  const effectiveResumeDetails = selectedResume || resumeDetails;

  // console.log(selectedResume,88888);  
  
  const { user } = useSelector((state: RootState) => state.authSlice);
  const dispatch = useDispatch();

  const isBulkEditHandler = () => {
    setIsBulkEdit(false);
    setIsSingleEdit(false);
    setShowEXP(true);
  };

  const isSingleEditHandler = (item: Experience) => {
    setIsSingleEdit(true);
    setIsBulkEdit(false);
    setShowEXP(true);
    setExperienceList({ experiences: [item] });
  };
  const isSingleDeleteHandler = (index: number) => {
    if (!effectiveResumeDetails?.experiences) return;

    const updatedExperiences = effectiveResumeDetails.experiences.filter(
      (_, i) => i !== index
    );
    dispatch(
      setResumeDetails({ ...effectiveResumeDetails, experiences: updatedExperiences })
    );
  };

  useEffect(() => {
    if (effectiveResumeDetails?.experiences && effectiveResumeDetails?.experiences?.length < 1 && editId==="") {
      if (user && user?.role === "jobseeker") {
        NavigateTo(AppRoute.JOBSEEKER_WORK_EXPERIENCE);
      } else if (user && user?.role === "localagents") {
        NavigateTo(AppRoute.AGENT_WORK_EXPERIENCE);
      }
    }
    // eslint-disable-next-line
  }, [effectiveResumeDetails]);

  const nextHandler = () => {
    if (user && user?.role === "jobseeker") {
      if (effectiveResumeDetails?.educations && effectiveResumeDetails?.educations?.length > 0)
        NavigateTo(AppRoute.JOBSEEKER_AFTER_ADDED_EDUCATION);
      else NavigateTo(AppRoute.JOBSEEKER_EDUCATION);
    } else if (user && user?.role === "localagents") {
      // console.log(AppRoute.AGENT_AFTER_ADDED_EDUCATION,false,{...(editId && { editId: editId })},958);
      // console.log(AppRoute.AGENT_EDUCATION,448);
      
      if ((effectiveResumeDetails?.educations && effectiveResumeDetails?.educations?.length > 0) || editId)
        NavigateTo(AppRoute.AGENT_AFTER_ADDED_EDUCATION,false,{...(editId && { editId: editId })});
      else NavigateTo(AppRoute.AGENT_EDUCATION);
    }
  };
  const prevHandler = () => {
    if (user && user?.role === "jobseeker") {
      if (effectiveResumeDetails?.experiences && effectiveResumeDetails?.experiences?.length > 0)
        NavigateTo(AppRoute.JOBSEEKER_MY_RESUME);
      else NavigateTo(AppRoute.JOBSEEKER_WORK_EXPERIENCE);
    } else if (user && user?.role === "localagents") {
      if ((effectiveResumeDetails?.experiences && effectiveResumeDetails?.experiences?.length > 0) || editId)
        NavigateTo(AppRoute.AGENT_MY_RESUME,false,{...(editId && { editId: editId })});
      else NavigateTo(AppRoute.AGENT_WORK_EXPERIENCE);
    }
  };

  return (
    <>
      <div className="main">
        <section className="profileJobDetails-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar  position-relative p-0">
                {user && user?.role === "jobseeker" && <SidebarScreen />}
                {user && user?.role === "localagents" && (
                  <AgentSidebarScreen />
                )}{" "}
              </div>
              <div className="col-lg-10 rightcontent p-0">
                {user && user?.role === "jobseeker" && <TopHeadScreen />}
                {user && user?.role === "localagents" && (
                  <AgentTopHeadScreen />
                )}{" "}
                <div className="profile-account-details-holder rightInnerScroll common-padd-lt-rt ">
                  <div className="row">
                    <div className="col-lg-12 mb-4">
                      <div className="profile-account-details">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="title">
                              <h2>My Resume</h2>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="myResume-holder">
                              <div className="login-form-area add-password-form mt-5">
                                <div className="stepbar">
                                  <ul>
                                    <li className="checked">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <FaCheck />
                                          </span>
                                        </div>
                                        <p>Step 1</p>
                                        <h4>About You</h4>
                                      </a>
                                    </li>
                                    <li className="inprogress">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <BsBriefcase />
                                          </span>
                                        </div>
                                        <p>Step 2</p>
                                        <h4>Experience</h4>
                                      </a>
                                    </li>
                                    <li className="">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <SlGraduation />
                                          </span>
                                        </div>
                                        <p>Step 3</p>
                                        <h4>Education</h4>
                                      </a>
                                    </li>
                                    <li className="">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <LiaAwardSolid />
                                          </span>
                                        </div>
                                        <p>Step 4</p>
                                        <h4>Achievements</h4>
                                      </a>
                                    </li>
                                    <li className="">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <HiOutlineLightBulb />
                                          </span>
                                        </div>
                                        <p>Step 5</p>
                                        <h4>Skills</h4>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>

                              <div className="comnbrdrGap profileEdit mb-4">
                                <div className="d-flex">
                                  <h3>Work & Experience</h3>
                                  <button
                                    className="editbtn"
                                    onClick={isBulkEditHandler}
                                  >
                                    <FiPlus /> Add
                                  </button>
                                </div>
                                {effectiveResumeDetails?.experiences &&
                                  effectiveResumeDetails?.experiences?.map(
                                    (item: any, index: number) => {
                                      // console.log(experienceList,8888);
                                      
                                      return (
                                        <div
                                          className="moreedit-holder"
                                          key={index}
                                        >
                                          <div className="d-flex">
                                            <h6>
                                              {moment(item?.from).format(
                                                "MMMM YYYY"
                                              )}{" "}
                                              -{" "}
                                              {moment(item?.to).format(
                                                "MMMM YYYY"
                                              )}
                                            </h6>
                                            <Dropdown
                                              as={NavItem}
                                              className="editnow"
                                            >
                                              <Dropdown.Toggle
                                                className="profiledropdown"
                                                as={NavLink}
                                              >
                                                <FiMoreVertical />
                                              </Dropdown.Toggle>
                                              <Dropdown.Menu>
                                                <Dropdown.Item
                                                  className=""
                                                  onClick={() =>
                                                    isSingleEditHandler(item)
                                                  }
                                                >
                                                  <LuPencilLine /> Edit
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                  onClick={() =>
                                                    isSingleDeleteHandler(index)
                                                  }
                                                >
                                                  <MdDeleteOutline /> Delete
                                                </Dropdown.Item>
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          </div>
                                          <h6>
                                            {item?.role} -{" "}
                                            <span>{item?.company}</span>
                                          </h6>
                                          <ul className="rightliarrow">
                                            {item?.responsibilities &&
                                              item?.responsibilities?.map(
                                                (resp: any, index: number) => {
                                                  return (
                                                    <div key={index}>
                                                      <li>{resp}</li>
                                                    </div>
                                                  );
                                                }
                                              )}
                                          </ul>
                                        </div>
                                      );
                                    }
                                  )}
                              </div>
                              <div className="flex-btn d-flex">
                                <Button
                                  className="btn btn-primary flex-btn d-flex"
                                  onClick={prevHandler}
                                >
                                  Prev
                                </Button>
                                <Button
                                  className="btn btn-primary flex-btn d-flex"
                                  onClick={nextHandler}
                                >
                                  Next
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />

      {/* Add Work Experience Modal */}
      <AddExpericeModal
        show={showEXP}
        onClose={handleCloseEXP}
        isBulkEdit={isBulkEdit}
        isSingleEdit={isSingleEdit}
        getExperienceList={experienceList}
        editDetails={selectedResume}
      />
      {/* Add Work Experience Modal */}
    </>
  );
};
export default ProfileAddedWorkExperienceScreen;
